<template>
  <v-row>
    <v-col class="col-3">
      <ArticleNavigation :active="selected_item" @selected_item="set_item" />
    </v-col>
    <v-col class="col-9">
      <v-card>
        <ArticleDisplay :article="article" />
        <v-divider></v-divider>
        <ArticlePagination :article="article" @selected_item="set_item" />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ArticleDisplay from "./ArticleDisplay.vue";
import ArticleNavigation from "./ArticleNavigation.vue";
import ArticlePagination from "./ArticlePagination.vue";
import { useArticlesStoreRefactor } from "@/stores/articlesStoreRefactor";

export default {
  name: "ArticleOverview",
  components: {
    ArticleDisplay,
    ArticleNavigation,
    ArticlePagination,
  },
  data() {
    return {
      selected_item: 15,
    };
  },
  computed: {
    article() {
      const articlesStore = useArticlesStoreRefactor();
      return articlesStore.getByIdWithRecursive(this.selected_item);
    },
  },
  async mounted() {
    const articlesStore = useArticlesStoreRefactor();
    await articlesStore.fetchAll();
  },
  methods: {
    set_item: function (x) {
      this.selected_item = x;
    },
  },
};
</script>
